/**
 * Helper that takes a timestamp string in format as 1720716662 and
 * returns a string in this format: 'March 26, 2024'
 */
export function formatTimestamp(timestamp: number): string {
  if (!timestamp) return '';
  const secondsToMilliseconds = timestamp * 1000;
  const newDate = new Date(secondsToMilliseconds);

  return newDate.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
